import React, { Component } from "react";
import { Segment } from "semantic-ui-react";
import { connect } from "react-redux";
import { validateSecurityToken, expireSession } from "../../actions/auth";
import { loadUi } from "../../actions/search";
import { getUserGlb } from "../../actions/userGlb";
import SecurityTokenForm from "../forms/SecurityTokenForm";
import { ERR_MSG_SESSION_EXPIRED } from "../../ErrorMessages";
import { updatePageHeaders } from "../../utils/PageHelper";
import { getContact } from "../navigation/Contact";
import api from "../../api";
import settings from "../../settings";

class SecurityTokenCheck extends Component {
  constructor(props) {
    super(props);
    const { cookies } = this.props;
    const securityCode = cookies.get("securitycode");
    this.state = {
      initialLoad: true,
      respData: {},
      loading: false,
      sendCodeLoading: false,
      error: undefined,
      sendNewStatus: undefined,
      newLinkMessage: undefined,
      securityCode,
    };
  }

  componentDidMount() {
    updatePageHeaders();
    const { securityCode } = this.state;
    this.submit(securityCode);
  }

  sendSecurityCode = () => {
    this.setState({ sendCodeLoading: true, initialLoad: false });
    let status = false;
    api.user
      .sendSecurityToken(settings.appName)
      .then((res) => {
        if (res.data.Status === "Success") {
          status = true;
        }
        this.setState({
          sendNewStatus: status,
          newLinkMessage: res.data.Message,
          sendCodeLoading: false,
          initialLoad: false,
          securityCode: "",
          error: undefined,
        });
      })
      .catch((err) => {
        console.log("Error during send security token", err.response);
        if (err.response && err.response.status === 401)
          this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
        this.setState({
          sendCodeLoading: false,
          sendNewStatus: status,
          newLinkMessage: err.response.data.Message,
        });
      });
  };

  submit = (securityToken) => {
    this.setState({ loading: true, error: undefined });
    if (securityToken === undefined || securityToken === "") {
      this.setState({ initialLoad: false, loading: false });
      return false;
    }
    return this.props
      .validateSecurityToken(securityToken, settings.appName)
      .then((res) => {
        if (res.data.Status === "Error") {
          localStorage.removeItem("sessionID");
          this.setState({
            loading: false,
            error: res.data.error,
            initialLoad: false,
          });
          return;
        }
        if (localStorage.sessionID) {
          const { cookies } = this.props;
          const d = new Date(res.data.ExpiryDate);
          d.setTime(d.getTime() + 5 * 60 * 1000);
          cookies.set("securitycode", securityToken, { path: "/", expires: d });
          this.props
            .getUserGlb()
            .then(() => {
              this.props
                .loadUi()
                .then(() => {
                  window.location.href = `/searchOptions`;
                })
                .catch((err) => {
                  console.log(
                    "Error during loadui - ",
                    err,
                    " - ",
                    err.response
                  );
                  this.setState({ loading: false, error: "Unable to load UI" });
                });
            })
            .catch((err) => {
              console.log(
                "Error while fetch user glb - ",
                err,
                " - ",
                err.response
              );
              this.setState({
                loading: false,
                initialLoad: false,
                error: "Unable to validate user GLB",
              });
            });
        }
      })
      .catch((err) => {
        console.log("Error during validate security token", err.response);
        if (err.response && err.response.status === 401)
          this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
        this.setState({
          loading: false,
          initialLoad: false,
          error: err.response
            ? err.response.data.Message
            : "Unable to validate security token",
        });
      });
  };

  render() {
    const {
      sendNewStatus,
      newLinkMessage,
      loading,
      sendCodeLoading,
      securityCode,
      error,
      initialLoad,
    } = this.state;
    return (
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="container-fluid padding-top-10">
          <div className="row security-box">
            <div className="col-lg-1" />
            <div className="col-lg-6 col-md-6 col-sm-6 login-box-left">
              <div className="security-heading">
                <strong>Security Code</strong>
              </div>
              <div className="padding-top-20" />
              {initialLoad === true && (
                <div>
                  <p>Processing security code validation...</p>
                  <Segment className="table-no-border box-shadow-none" loading>
                    <br />
                  </Segment>
                </div>
              )}
              {sendNewStatus === true && (
                <SecurityTokenForm
                  submit={this.submit}
                  respData={this.state.respData}
                  loading={loading}
                  error={this.state.error}
                  cookies={this.props.cookies}
                  securityCode={this.state.securityCode}
                />
              )}
              {/* <div className="padding-top-20" /> */}
              {/* If you do not have the code or it is expired, click{" "} */}
              {error !== undefined && (<p className="red-text">{error}</p>)}
              {!loading &&
                (securityCode === undefined ||
                  securityCode === "" ||
                  !sendNewStatus) && (
                  <Segment
                    loading={sendCodeLoading}
                    className="simple-segment padding-left-0"
                  >
                    {(sendNewStatus === undefined ||
                      sendNewStatus === false) && (
                      <div>
                        Please click{" "}
                        <span
                          onClick={this.sendSecurityCode}
                          tabIndex="-2"
                          role={"button"}
                          className="url-link-activity"
                        >
                          here
                        </span>{" "}
                        to send the code to account registered email.
                      </div>
                    )}
                    {sendNewStatus === true && error === undefined && (
                      <div className="success-message padding-bottom-20">
                        {newLinkMessage}
                      </div>
                    )}
                    {sendNewStatus === false && error === undefined && (
                      <div className="failed-message padding-bottom-20">
                        {newLinkMessage}
                      </div>
                    )}
                  </Segment>
                )}
            </div>
            <div className="col-lg-1 col-md-2 col-sm-2" />
            <div className="col-lg-4 col-md-3 col-sm-3 login-box-right">
              <div className="padding-top-35">{getContact()}</div>
              <div className="padding-top-20" />

              <div className="col-lg-2 col-md-2 col-sm-2" />

              <div className="padding-top-20" />

              <div className="hide-on-smallscreen">
                <div className="padding-top-20" />

                <div className="padding-top-20" />

                <div className="padding-top-20" />
              </div>
              <div className="padding-top-20" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  validateSecurityToken,
  expireSession,
  getUserGlb,
  loadUi,
})(SecurityTokenCheck);



// WEBPACK FOOTER //
// ./src/components/pages/SecurityTokenCheck.js